import { FormularioService } from 'src/app/services/formulario.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DashboardMenuDTO } from 'src/app/entity/dto/dashboard-menu.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { GeneralService } from 'src/app/services/general.service';
import {
  DropDownListCategorySite,
  DropDownListSiteRecebimentoDTO,
  eCategoryListSiteRecebimento,
} from 'src/app/entity/dto/dropdownlist.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { eAreaType, eAreaTypeNumber } from 'src/app/entity/enum/enum-area-type';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  public dashboardMenuDTO?: Array<DashboardMenuDTO> =
    new Array<DashboardMenuDTO>();
  public formulario: FormGroup;
  public listSite?: Array<DropDownListSiteRecebimentoDTO> =
    new Array<DropDownListSiteRecebimentoDTO>();
  public listSiteOriginal?: Array<DropDownListSiteRecebimentoDTO> =
    new Array<DropDownListSiteRecebimentoDTO>();
  public enableCursor: boolean;
  listCategorySite: DropDownListCategorySite[] = [];
  areaSelect: string = eAreaType.commercial;

  public siteType: string;

  constructor(
    protected generalService: GeneralService,
    protected formBuilder: FormBuilder,
    protected formularioService: FormularioService
  ) {
    this.formulario = this.formBuilder.group({
      site: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.listSiteOriginal = this.listSite;
    const value: string = this.generalService.getLocalStorageDataSite();
    if (!!value) {
      this.formulario.get('site').setValue(value);
      this.enableCursor = true;
    } else {
      this.enableCursor = false;
    }
    this.buildDashboardCards();
    this.getListCategorySite();

  }


  buildDashboardCards(): void {
    const getSiteInfo = localStorage.getItem("area-select")
    if (getSiteInfo === "Pré-Básica") {
      this.dashboardMenuDTO = [{
        link: 'formqua007',
        enumForm: EnumForm.FormQua007,
        menu: 'SEM-PRO-FOR-QUA-007',
        formulario: 'Formulário de recebimento',
        imagem: 'qua007.png',
      }, {
        link: 'formcd006',
        enumForm: EnumForm.FormCd006,
        menu: 'SEM-PRO-FOR-CD-006',
        formulario: 'Debulha (CD006)',
        imagem: 'cd006.png',
      },
      {
        link: 'formsec002',
        enumForm: EnumForm.FormSec002,
        menu: 'SEM-PRO-FOR-SEC-002',
        formulario: 'Secador (SEC002)',
        imagem: 'sec002.png',
      }, {
        link: 'formqua042',
        enumForm: EnumForm.FormQua042,
        menu: 'SEM-PRO-FOR-QUA-042',
        formulario: 'Ensaque (QUA042)',
        imagem: 'qua042.png',

      },
      {
        link: 'formrs009',
        enumForm: EnumForm.FormRs009,
        menu: 'SEM-PRO-FOR-RS-009',
        formulario: 'Sala Recebimento (RS009)',
        imagem: 'qua007.png',

      },
      {
        link: 'formrs005',
        enumForm: EnumForm.FormRs005,
        menu: 'SEM-PRO-FOR-RS-005',
        formulario: 'Seleção e Debulha (RS005)',
        imagem: 'rs005.png',

      },


      ];

    }
    else if (getSiteInfo === "Básica") {
      this.dashboardMenuDTO = [
        // tslint:disable-next-line: max-line-length
        {
          link: 'formqua007',
          enumForm: EnumForm.FormQua007,
          menu: 'SEM-PRO-FOR-QUA-007',
          formulario: 'Recebimento (QUA007)',
          imagem: 'qua007.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formrs009',
          enumForm: EnumForm.FormRs009,
          menu: 'SEM-PRO-FOR-RS-009',
          formulario: 'Sala Recebimento (RS009)',
          imagem: 'qua007.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formrs005',
          enumForm: EnumForm.FormRs005,
          menu: 'SEM-PRO-FOR-RS-005',
          formulario: 'Despalha e Seleção (RS005)',
          imagem: 'rs005.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formsec002',
          enumForm: EnumForm.FormSec002,
          menu: 'SEM-PRO-FOR-SEC-002',
          formulario: 'Secador (SEC002)',
          imagem: 'sec002.png',

        },
        // tslint:disable-next-line: max-line-length
        // { link: '', enumForm: EnumForm.Desconhecido, menu: 'SEM-PRO-FOR-CD-006', formulario: 'Debulha (CD006)', imagem: 'sec002.png' },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formcd001/' + this.areaSelect,
          enumForm: EnumForm.FormCd001Classificacao,
          menu: 'SEM-PRO-FOR-CD-001',
          formulario: 'Classificação (CD001)',
          imagem: 'cd001.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formcd003',
          enumForm: EnumForm.FormCd003,
          menu: 'SEM-PRO-FOR-CD-003',
          formulario: 'Limpeza (CD003)',
          imagem: 'cd001.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formet004',
          enumForm: EnumForm.Desconhecido,
          menu: 'SEM-PRO-FOR-ET-004',
          formulario: 'Tratamento (ET004)',
          imagem: 'et004.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formqua042',
          enumForm: EnumForm.FormQua042,
          menu: 'SEM-PRO-FOR-QUA-042',
          formulario: 'Ensaque (QUA042)',
          imagem: 'qua042.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formcd006',
          enumForm: EnumForm.FormCd006,
          menu: 'SEM-PRO-FOR-CD-006',
          formulario: 'Debulha (CD006)',
          imagem: 'cd006.png',

        },
        //NOVA
        {
          link: 'formmake745',
          enumForm: EnumForm.FormCPBMAKE000745,
          menu: 'CPB-MAKE-000745',
          formulario: 'Dados Ensaque CS (CPB-MAKE-000745)',
          imagem: 'cd006.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'manageSequence',
          enumForm: EnumForm.ManageSequence,
          menu: 'Estratégia de torre (Sequência e orientações)',
          formulario: 'Estratégia de torre (Sequência e orientações)',
          imagem: 'logoseedsview.png',

        },
      ];
    }
    else if (getSiteInfo === "Comercial") {
      this.dashboardMenuDTO = [
        // tslint:disable-next-line: max-line-length
        {
          link: 'formqua007',
          enumForm: EnumForm.FormQua007,
          menu: 'SEM-PRO-FOR-QUA-007',
          formulario: 'Recebimento (QUA007)',
          imagem: 'qua007.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formrs009',
          enumForm: EnumForm.FormRs009,
          menu: 'SEM-PRO-FOR-RS-009',
          formulario: 'Sala Recebimento (RS009)',
          imagem: 'qua007.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formrs005',
          enumForm: EnumForm.FormRs005,
          menu: 'SEM-PRO-FOR-RS-005',
          formulario: 'Despalha e Seleção (RS005)',
          imagem: 'rs005.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formsec002',
          enumForm: EnumForm.FormSec002,
          menu: 'SEM-PRO-FOR-SEC-002',
          formulario: 'Secador (SEC002)',
          imagem: 'sec002.png',

        },
        // tslint:disable-next-line: max-line-length
        // { link: '', enumForm: EnumForm.Desconhecido, menu: 'SEM-PRO-FOR-CD-006', formulario: 'Debulha (CD006)', imagem: 'sec002.png' },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formcd001/' + this.areaSelect,
          enumForm: EnumForm.FormCd001Classificacao,
          menu: 'SEM-PRO-FOR-CD-001',
          formulario: 'Classificação (CD001)',
          imagem: 'cd001.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formcd003',
          enumForm: EnumForm.FormCd003,
          menu: 'SEM-PRO-FOR-CD-003',
          formulario: 'Limpeza (CD003)',
          imagem: 'cd001.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formet004',
          enumForm: EnumForm.Desconhecido,
          menu: 'SEM-PRO-FOR-ET-004',
          formulario: 'Tratamento (ET004)',
          imagem: 'et004.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formqua042',
          enumForm: EnumForm.FormQua042,
          menu: 'SEM-PRO-FOR-QUA-042',
          formulario: 'Ensaque (QUA042)',
          imagem: 'qua042.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'formcd006',
          enumForm: EnumForm.FormCd006,
          menu: 'SEM-PRO-FOR-CD-006',
          formulario: 'Debulha (CD006)',
          imagem: 'cd006.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'camisa-trieur',
          enumForm: EnumForm.FormCamisaTrieur,
          menu: 'Configuração de Classificação - Camisa de Trieur',
          formulario: 'Configuração de Classificação - Camisa de Trieur',
          imagem: 'logoseedsview.png',

        },
        // tslint:disable-next-line: max-line-length
        {
          link: 'manageSequence',
          enumForm: EnumForm.ManageSequence,
          menu: 'Estratégia de torre (Sequência e orientações)',
          formulario: 'Estratégia de torre (Sequência e orientações)',
          imagem: 'logoseedsview.png',

        }
      ];
    }
  }

  goToRoute(item?: DashboardMenuDTO): void {
    if (!!item.link) {
      this.generalService.setValue(item.menu);
      this.generalService.goToRoute(item.link);
    }
  }

  public createFilterSite(value: string): void {
    if (!!value && value.length > 0) {
      if (
        this.listSiteOriginal.filter((x) =>
          x.initials?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listSite = this.listSiteOriginal.filter((x) =>
          x.initials?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listSite = this.listSiteOriginal;
      }
    } else {
      this.listSite = this.listSiteOriginal;
    }
  }

  public changeSite(value: string): void {
    if (!!localStorage.getItem('data_site')) {
      localStorage.setItem('data_site', value);
      this.enableCursor = true;
    } else {
      localStorage.setItem('data_site', value);
      this.enableCursor = true;
    }
  }

  hasErrorFormControl(): string {
    return this.formulario.get('site').hasError('required')
      ? 'Para poder acessar os formularios, você deve selecionar o site!'
      : '';
  }

  getListCategorySite = async () => {
    await this.generalService.requestGetListSiteCategory().then((res) => {
      console.log(res)
      this.listCategorySite = res;
      this.getListSite();
    });
  };

  getListSite = (event?: MatTabChangeEvent) => {
    if (event !== undefined) {
      this.changeArea(event.tab.textLabel);
      this.generalService
        .requestGetListSiteRecebimento(event.tab.textLabel)
        .then((res) => {
          this.listSite = this.generalService.orderByDropDownList(res, false);
        });
    }
  };

  changeArea = (area: string) => {
    let newArea = eAreaTypeNumber.all
    switch (area) {
      case eAreaType.preBasic:
        this.areaSelect = eAreaType.preBasic;
        newArea = eAreaTypeNumber.preBasic;
        break;

      case eAreaType.basic:
        this.areaSelect = eAreaType.basic;
        newArea = eAreaTypeNumber.basic;
        break;

      default:
        this.areaSelect = eAreaType.commercial;
        newArea = eAreaTypeNumber.commercial;
        break;
    }

    localStorage.setItem('area-select', this.areaSelect);
    localStorage.setItem('area-select-number', newArea);

    this.buildDashboardCards();
  };
}